export type TClientAccount = {
  id: number;
  description: string;
};

export enum EAuthState {
  INITIALIZING = 'initializing',
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
  ERROR = 'error',
}

export const B2CORE_IFRAME_ID = 'b2core-iframe-tv';

export type TEmbedPostMessage = {
  type: 'onSuccessLogin';
  payload: unknown;
};

export interface ISimpleMap<TValue> {
  [key: string]: TValue;
}

export interface IAccountManagerData {
  balance: number;
  equity: number;
  freeMargin: number;
  margin: number;
  marginLevel: number;
  pl: number;
  promo: number;
  title: string;
}

export type TTickData = {
  symbol: string;
  timestamp: number;
  bid: number;
  ask: number;
  volume: number;
};
